export default {"src":"/_next/static/media/error404.f5ea1a2e.svg","height":504,"width":652,"blurWidth":0,"blurHeight":0};